import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['from', 'to'];

  changeFromHandler() {
    this.autocompleteTo();
  }

  autocompleteTo() {
    if (this.hasToTarget && this.hasFromTarget) {
      this.toTarget.value = this.fromTarget.value;
      this.toTarget.dispatchEvent(new Event('change'));
    }
  }
}
